function clean(value) {
  return String(value || "").trim();
}

function uniqueValues(values = []) {
  return Array.from(new Set(values.map(clean).filter(Boolean)));
}

export function buildOptionCombinations(options = []) {
  const valid = options
    .map((opt) => ({
      name: clean(opt?.name),
      values: uniqueValues(opt?.values || []),
    }))
    .filter((opt) => opt.name && opt.values.length > 0);

  if (!valid.length) return [];

  return valid.reduce((acc, opt) => {
    if (!acc.length) {
      return opt.values.map((value) => ({ [opt.name]: value }));
    }

    const next = [];
    for (const combo of acc) {
      for (const value of opt.values) {
        next.push({ ...combo, [opt.name]: value });
      }
    }
    return next;
  }, []);
}

export function createGeneratedVariant(optionValues) {
  return {
    optionValues,
    sku: "",
    price: "",
    imageUrl: null,
    isActive: true,
  };
}

export function reconcileVariantsWithOptions(existingVariants = [], options = []) {
  const combos = buildOptionCombinations(options);
  if (!combos.length) return [];

  const existingByKey = new Map(
    existingVariants.map((variant) => [makeVariantKey(variant?.optionValues || {}), variant])
  );

  return combos.map((combo) => {
    const match = existingByKey.get(makeVariantKey(combo));
    return match ? { ...match, optionValues: combo } : createGeneratedVariant(combo);
  });
}

export function countMissingCombos(options = [], variants = []) {
  const comboKeys = new Set(buildOptionCombinations(options).map((combo) => makeVariantKey(combo)));
  const variantKeys = new Set(variants.map((variant) => makeVariantKey(variant?.optionValues || {})));

  let missing = 0;
  comboKeys.forEach((key) => {
    if (!variantKeys.has(key)) missing += 1;
  });

  return missing;
}

export function makeVariantKey(optionValues = {}) {
  return Object.entries(optionValues || {})
    .sort(([left], [right]) => String(left).localeCompare(String(right)))
    .map(([key, value]) => `${key}:${value}`)
    .join("|");
}
